/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: NumericInputShapeControl.ts
 * Project: mle-client-n
 * Committed last: 2022/1/14 @ 1650
 * ---
 * Description:
 */

import { ControlTypes }                         from '../../selection-properties';
import { ShapeControl, ShapeControlInitParams } from './ControlGroup';

export class NumericShapeControl extends ShapeControl<number> {
  public min?: number;
  public max?: number;
  public step?: number;

  constructor(initParams: ShapeControlInitParams<number>, {
    min,
    max,
    step
  }: { min?: number, max?: number, step?: number }) {
    super(initParams);
    this.min = min;
    this.max = max;
    this.step = step;
    this.controlType = ControlTypes.NUMBER;
  }
}